import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  Companion_getInstance3qu5ydsg8audm as Companion_getInstance,
  toLocalDateTime3u4c8ydzr4ubp as toLocalDateTime,
} from '../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/TimeZone.mjs';
import {
  renderToString20fhv3rgk9b94 as renderToString,
  renderToString2kyj9dlz89tdi as renderToString_0,
} from './LocalTimeRender.js.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Enum3alwj03lh1n41 as Enum } from '../../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function renderToString_1(_this__u8e3s4, size, zone, includeWeekday, includeYear, includeEra) {
  size = size === VOID ? RenderSize_Full_getInstance() : size;
  zone = zone === VOID ? Companion_getInstance().q27() : zone;
  includeWeekday = includeWeekday === VOID ? false : includeWeekday;
  includeYear = includeYear === VOID ? true : includeYear;
  includeEra = includeEra === VOID ? false : includeEra;
  return renderToString(toLocalDateTime(_this__u8e3s4, zone), size, includeWeekday, includeYear, includeEra);
}
var RenderSize_Numerical_instance;
var RenderSize_Abbreviation_instance;
var RenderSize_Full_instance;
var RenderSize_entriesInitialized;
function RenderSize_initEntries() {
  if (RenderSize_entriesInitialized)
    return Unit_instance;
  RenderSize_entriesInitialized = true;
  RenderSize_Numerical_instance = RenderSize().xcx('Numerical', 0);
  RenderSize_Abbreviation_instance = RenderSize().xcx('Abbreviation', 1);
  RenderSize_Full_instance = RenderSize().xcx('Full', 2);
}
var RenderSizeClass;
function RenderSize() {
  if (RenderSizeClass === VOID) {
    class $ extends Enum() {
      static xcx(name, ordinal) {
        return this.c4(name, ordinal);
      }
    }
    initMetadataForClass($, 'RenderSize');
    RenderSizeClass = $;
  }
  return RenderSizeClass;
}
function renderDateToString(_this__u8e3s4, size, zone, includeWeekday, includeYear, includeEra) {
  size = size === VOID ? RenderSize_Full_getInstance() : size;
  zone = zone === VOID ? Companion_getInstance().q27() : zone;
  includeWeekday = includeWeekday === VOID ? false : includeWeekday;
  includeYear = includeYear === VOID ? true : includeYear;
  includeEra = includeEra === VOID ? false : includeEra;
  return renderToString_0(toLocalDateTime(_this__u8e3s4, zone).v1w(), size, includeWeekday, includeYear, includeEra);
}
function RenderSize_Numerical_getInstance() {
  RenderSize_initEntries();
  return RenderSize_Numerical_instance;
}
function RenderSize_Full_getInstance() {
  RenderSize_initEntries();
  return RenderSize_Full_instance;
}
//region block: exports
export {
  renderDateToString as renderDateToString2ahaatg50tfe4,
  renderToString_1 as renderToString1atd3jbop96tk,
  RenderSize_Full_getInstance as RenderSize_Full_getInstancer1do7w9ydi0t,
  RenderSize_Numerical_getInstance as RenderSize_Numerical_getInstance1z6x2shksihh7,
};
//endregion

//# sourceMappingURL=LocalTimeRender.mjs.map
